module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FMGhpz/tc-custom/9781426894657.jpg?1702639373004",
      "alt": "This image is the cover for the book 40 Souls to Keep"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("40 Souls to Keep\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A healer. A helper. A race against time—and an otherworldly danger—to save a child. A male/male romantic suspense thriller with a supernatural twist.")]), _c('br'), _c('br'), _vm._v("Seven years ago, Jase awoke with the mystical power to heal people—and no memory of his past. The only clue to his identity is the number forty tattooed on his arm. Driven by a mission he doesn’t understand, Jase follows his visions to those he’s meant to save. He is convinced that the fortieth person he’s drawn to—a little girl named Macy Pearl—is the key to finally learning the truth . . . "), _c('br'), _c('br'), _vm._v("Social worker Lucas Jacobson has made a promise to protect Macy, orphaned when her parents were brutally murdered. So when Jase shows up in Naples claiming he’s there to heal the child, Lucas is wary, despite his attraction to the enigmatic stranger."), _c('br'), _c('br'), _vm._v("Then Macy is abducted, and Lucas has no choice but to trust in Jase. Scouring the city from its glitzy resorts to its seedy underbelly only deepens the mystery—and draws the two men closer. But Jase is certain of one thing: if Macy dies, a dark fate awaits them all."), _c('br'), _c('br'), _c('b', [_vm._v("“Drew maintains a high level of suspense as the men become lovers and determine who wants Macy and why, interspersing flashbacks to Jase’s seven years as a traveling healer.” —"), _c('i', [_vm._v("Publishers Weekly")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Libby Drew\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0